import request from './request';

const uri = 'upload/';

const upload = {
  post: (options) => request(uri, { method: 'POST', ...options }),
};

export default upload;
